// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Pip-indicator_f5bd034a","online":"Pip-online_e651c213","away":"Pip-away_9c1a3001","notification":"Pip-notification_20c7e7a5"};